// react-router-dom components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function DefaultFooter({ content }) {
  const { brand, socials, menus, copyright } = content;
  return (
    <MKBox
      component="footer"
      // sx={({ palette: { primary }, functions: { rgba } }) => ({
      //   backgroundColor: rgba(primary.main, 0.8),
      // })}
    >
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={12} md={3} xl={4} sx={{ textAlign: "center", mb: 3 }}>
            <MKBox
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              <Link to={brand.route}>
                <MKBox component="img" src={brand.image} alt={brand.name} maxWidth="6rem" mb={2} />
              </Link>
              <MKTypography variant="h6">{brand.name}</MKTypography>
              <MKBox display="flex" alignItems="center" mt={3}>
                {socials?.map(({ icon, link }, key) => (
                  <MKTypography
                    key={link}
                    component="a"
                    href={link}
                    target="_blank"
                    rel="noreferrer"
                    variant="h5"
                    color="dark"
                    opacity={0.8}
                    mr={key === socials.length - 1 ? 0 : 2.5}
                  >
                    {icon}
                  </MKTypography>
                ))}
              </MKBox>
            </MKBox>
          </Grid>
          {menus.map(({ name: title, items, info }) => (
            <Grid
              key={title}
              item
              xs={info ? 6 : 3}
              md={info ? 5 : 2}
              xl={info ? 4 : 2}
              sx={{ mb: 3 }}
            >
              <MKTypography
                display="block"
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
                mb={1}
              >
                {title}
              </MKTypography>
              <MKBox component="ul" p={0} m={0} sx={{ listStyle: "none" }}>
                {items?.map(({ name, route, href }) => (
                  <MKBox key={name} component="li" p={0} m={0} lineHeight={1.25}>
                    {href ? (
                      <MKTypography
                        component="a"
                        href={href}
                        target="_blank"
                        rel="noreferrer"
                        variant="button"
                        fontWeight="regular"
                        textTransform="capitalize"
                      >
                        {name}
                      </MKTypography>
                    ) : (
                      <MKTypography
                        component={Link}
                        to={route}
                        variant="button"
                        fontWeight="regular"
                        textTransform="capitalize"
                      >
                        {name}
                      </MKTypography>
                    )}
                  </MKBox>
                ))}
                {info?.map(({ details, icon, name }) => (
                  <MKBox key={name} component="li" p={0} m={0} lineHeight={1.25} mb={2}>
                    {icon ? (
                      <MKBox display="flex" variant="button">
                        <MKTypography variant="button">
                          <i className={icon} />
                        </MKTypography>
                        <MKTypography
                          component="span"
                          variant="button"
                          opacity={0.8}
                          ml={2}
                          fontWeight="regular"
                        >
                          {details}
                        </MKTypography>
                      </MKBox>
                    ) : (
                      <MKTypography
                        component="span"
                        variant="button"
                        opacity={0.8}
                        ml={2}
                        fontWeight="regular"
                      >
                        {details}
                      </MKTypography>
                    )}
                  </MKBox>
                ))}
              </MKBox>
            </Grid>
          ))}
          <Grid item xs={12} sx={{ textAlign: "center", my: 3 }}>
            {copyright}
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

DefaultFooter.defaultProps = {
  transparent: false,
};
// Typechecking props for the DefaultFooter
DefaultFooter.propTypes = {
  transparent: PropTypes.bool,
  content: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.object, PropTypes.array])).isRequired,
};

export default DefaultFooter;
